"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : TAB : STYLES --------------- ++++++++++ */


var _default = {
  tabs: {
    '& .tabheader': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .tabbody': {
      background: _index.theme.color.light.light.swatch,
      borderRadius: (0, _index.pxToEm)(4),
      border: (0, _index.replacePXinStringWithEM)("1px solid #ECF0F7"),
      boxShadow: (0, _index.replacePXinStringWithEM)("0 1px 1px 0 #EDF1FA"),
      width: '100%',
      position: 'relative',
      padding: (0, _index.replacePXinStringWithEM)('25px 40px'),
      textAlign: 'left',
      zIndex: '1',
      transition: 'height .3s linear 0s'
    }
  }
};
exports.default = _default;